const axios = require('axios')

const brasil = axios.create({
  baseURL: `https://brasilapi.com.br/api`,
  timeout: 7000,
  headers: { 'Content-Type': 'application/json' }
})

export default brasil



// WEBPACK FOOTER //
// ./src/services/brasil.js